export const TEXTS = {
  CLEAR: 'clear',
  GO_BACK: 'go back',
  PLACEHOLDER: 'Search for products, styles, brands',
};
